import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { isEmpty, } from 'lodash';
import { useLocation, } from 'react-router';

import env from '../env';
import useUser from './hooks/useUser';

const navItems = [
  {
    path: _ => '/',
    label: 'ダッシュボード',
    regExp: /^\/$/,
  },
  {
    path: _ => '/dailyPL',
    label: '損益',
  },
  {
    path: _ => '/expenses',
    label: '経費/支出',
    regExp: /^\/(purchases|expenses)/,
  },
  {
    path: _ => '/productKpiAnalysis',
    label: '商品分析',
  },
  {
    path: _ => '/reviewRequests',
    label: 'レビュー依頼',
    regExp: /^\/reviewRequests/,
  },
  {
    path: _ => '/settings',
    label: '設定',
    regExp: /^\/settings/,
  },
];

export default function TenantSideNav (props) {
  const { className, style, isCollapsed, onToggle, ...extraProps } = props;
  const location = useLocation();
  const user = useUser();

  if (isCollapsed) {
    return (
      <div className={classnames('position-fixed ps-3 side-nav', className)} style={{ zIndex: 1000, bottom: 0, ...style }} {...extraProps}>
        <button type="button" className="btn btn-sm btn-light border" onClick={onToggle} title="メニューを開く">
          <span className="fas fa-angles-right" />
        </button>
      </div>
    );
  }

  return (
    <div className={classnames('position-fixed ps-3 side-nav', className)} style={{ zIndex: 1000, bottom: 0, ...style }} {...extraProps}>
      <div className="card p-3" style={{ minHeight: 600, }}>
        <div className="d-flex justify-content-end mb-2">
          <button type="button" className="btn btn-sm btn-light border" onClick={onToggle} title="メニューを閉じる">
            <span className="fas fa-angles-left" />
          </button>
        </div>
        <ul className="h-100 nav nav-pills flex-column mb-0">
        {
          (user.role === 'admin' ? navItems : navItems.filter(_ => !_.admin)).map(({ path, label, regExp, }) => {
            return (
              <li className="nav-item" key={label}>
                <Link to={path(props)} className={classnames('nav-link', { active: location.pathname.match(regExp || path(props)) })}>
                  {label}
                </Link>
              </li>
            );
          })
        }
        </ul>
      </div>
    </div>
  );
};
